export default {
  contracts: {
    activeContracts: 'Активные контракты',
    productsAndHours: 'Поддерживаемые продукты и остаток часов поддержки',
    supported: 'Поддерживается',
    notSupported: 'Не поддерживается',
    contact: 'Менеджер',
    dividerText: 'Поддерживаемые системы и включенные часы поддержки'
  },
  states: {
    OPEN: 'Открытые',
    AWAITING_REPLY: 'Ожидают ответа',
    CLOSED: 'Закрытые',
    FEEDBACK_REQUIRED: 'Ожидают отзыв',
    onlyRequired: 'Показать только требующие действий',
    onlyWorkRequests: 'Показать только одобрение рабочих запросов'
  },
  common: {
    New: 'Новые',
    Open: 'Открытые',
    Pending: 'В ожидании',
    Closed: 'Закрытые',
    create: 'Создать',
    cancel: 'Отмена',
    goBack: 'Вернуться',
    close: 'Закрыть',
    goToMain: 'Вернуться на главную страницу',
    news: 'Новости',
    moreInfo: 'Подробнее',
    change: 'изменить',
    send: 'Отправить',
    description: 'Описание',
    skip: 'Пропустить'
  },
  property: {
    name: 'Предприятие',
    allProperties: 'Все предприятия',
    selectProperty: 'Выберите предприятие'
  },
  product: {
    name: 'Продукт',
    allProducts: 'Все продукты',
    selectProduct: 'Выберите продукт',
    noProducts: 'Нет продуктов'
  },
  chart: {
    chooseMonth: 'Выберите месяц',
    noData: 'Нет данных за текущий период'
  },
  navigation: {
    main: 'ГЛАВНАЯ',
    interactions: 'ЗАЯВКИ',
    contracts: 'КОНТРАКТЫ',
    signOut: 'ВЫЙТИ'
  },
  tickets: {
    createNewTitle: 'Создание новой заявки',
    title: 'Заголовок',
    noTickets: 'Нет заявок с текущими настройками фильтров',
    search: 'Поиск',
    createNew: 'Создать новую',
    reopenOrDisagree: 'Переоткрыть заявку / несолгасие',
    escalation: 'Эскалация заявки',
    disagree: 'Не согласен',
    reason: 'Причина',
    reopen: 'Переоткрыть',
    escalate: 'Эскалировать',
    opinionTitle: 'Ваше мнение важно для нас!',
    opinionBody:
      'Пожалуйста, оцените качество работы нашего персонала поддержки.',
    time: 'Время решения',
    qualification: 'Квалификация специалиста',
    communication: 'Навыки общения',
    sendFeedback: 'Отправить отзыв',
    leaveFeedback: 'Оставить отзыв',
    close: 'Закрыть заявку',
    alreadyHasFeedback: 'По данной заявке уже имеется отзыв',
    feedbackHasBeenSent: 'Отзыв успешно отправлен',
    ticketHasBeenReopened: 'Заявка снова открыта',
    ticketHasBeenEscalated: 'Заявка эскалирована',
    comment: 'Комментарий',
    keyPlaceholder: 'Напишите сообщение',
    approve: 'Утвердить',
    reject: 'Отклонить',
    workRequestOnContractNotification:
      'Уважаемый {{fullName}},\n\nВ настоящее время у вас есть {{hoursInSupportContract}} часов дополнительных услуг, включенных в ваш контракт на поддержку.\nДля выполнения заявки {{workRequestId}} потребуется {{hoursRequested}} часов. \n\nПожалуйста, одобрите вычет часов из баланса для выполнения вышеуказанной задачи.\nСпасибо\n\nС уважением,\n{{author}}',
    workRequestChargeableNotification:
      'Уважаемый {{fullName}},\n\nЭта работа не включена в услугу и не гарантируется договором. Мы будем рады составить график и помочь. Мы оцениваем {{hoursRequested}} часов для выполнения запроса {{workRequestId}}.\n\nСтоимость выполнения этого запроса составит {{amount}}.\nЭто предложение действительно в течение 7 дней с даты выпуска. \nЕсли фактическое затраченное время превышает исходное предложение, запрашивающему будет отправлена дополнительная форма запроса на дополнительные часы для утверждения. Если расчетное время меньше исходного предложения, исходное предложение будет отменено и будет изменено предложение. быть отправлены.\n\nПожалуйста, одобрите дополнительную работу и оплату.\n\nС уважением,\n{{author}}',
    workRequestCommentRequired: 'Укажите причину отклонения заявки на работу.'
  },
  severity: {
    name: 'Приоритет',
    0: 'Стандартный',
    1: 'Высокий',
    2: 'Критический',
    wantToChange: 'Хотите изменить приоритет?',
    changeSeverityButton: 'Изменить'
  },
  forms: {
    password: 'Пароль',
    confirmPassword: 'Подтвердите пароль',
    passwordsDoNotMatch: 'Пароли не совпадают',
    updatePassword: 'Обновить пароль',
    askRestore: 'Запросить восстановление пароля',
    remember: 'Запомнить этот компьютер',
    restorePassword: 'Забыли пароль?',
    signIn: 'Войти',
    required: 'Обязательное поле',
    invalidEmail: 'Неправильный адрес почты'
  },
  transactions: {
    date: 'Дата',
    type: 'Тип',
    comment: 'Комментарий',
    status: 'Статус',
    subject: 'Заявка на работы',
    hours: 'Часы',
    name: 'Список транзакций',
    viewTransactions: 'Посмотреть транзакции',
    types: {
      WORK_REQUEST: 'Заявка на работы',
      CONTRACT_ACTIVATION: 'Активация контракта',
      CONTRACT_EXPIRATION: 'Истечение срока контракта',
      MANUAL_ADJUST_ADD: 'Ручное изменение - добавление',
      MANUAL_ADJUST_DEDUCT: 'Ручное изменение - уменьшение',
      TRANSFER_PROPERTY: 'Перемещение между предприятиями',
      TRANSFER_PRODUCT: 'Перемещение между продуктами'
    }
  },
  transactionDetail: {
    name: 'Детали транзакции',
    num: 'Номер',
    insertTime: 'Дата создания',
    requestorName: 'Имя реквестора',
    subject: 'Тема',
    status: 'Статус',
    acceptTime: 'Дата принятия',
    cancelTime: 'Дата отмены',
    hours: 'Кол-во часов',
    hourType: 'Источник',
    workText: 'Описание работ',
    plannedDate: 'Планируемая дата выполнения'
  },
  statuses: {
    Approved: 'Подтвержден',
    Pending: 'Ожидает',
    Cancelled: 'Отменен'
  },
  hoursTypes: {
    'Included in contract': 'Включенные в контракт',
    'Installation hours': 'Часы установки',
    'Preventative visit': 'Профилактический визит',
    Chargeable: 'Платные работы'
  },
  errors: {
    unknown: 'Неизвестная ошибка',
    1000: 'Ошибка запроса',
    1001: 'Ошибка запроса',
    1: 'Неправильный логин или пароль',
    2: 'Истек срок действия сессии',
    3: 'Ошибка: не удалось найти предприятие',
    4: 'Ошибка: не удалось найти продукт',
    7: 'Неизвестная заявка',
    8: 'Заявка уже закрыта',
    11: 'Доступ запрещен',
    12: 'Неизвестная транзакция',
    660: 'Заявка не может быть закрыта в данный момент, т.к. содержит неоконченные работы. Поддержка получила Вашу заявку на закрытие. Спасибо за понимание.'
  },
  phrases: {
    noAccount: ['Нет аккаунта?', 'Свяжитесь с нами'],
    dnd: [
      'Перетащите файлы сюда или',
      'Отпустите файлы здесь или',
      'просмотрите'
    ]
  }
}
